import { type CustomerDTO } from "@ifa/utils";
import { InsuredSection } from "../../CustomerDetail/components/insured/InsuredSection";

interface InsuredViewProps {
  customer: CustomerDTO | null;
  onBack: () => void;
}

export function InsuredView({ customer }: InsuredViewProps) {
  return (
    <div style={{
      height: "100%",
      overflow: "auto",
    }}>
      <InsuredSection
        customer={customer}
        onRefresh={() => {}}
        fromCustomerList={true}
        customerId={customer?.customerId}
      />
    </div>
  );
}
